import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializerService } from '@app/app-initializer.service';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  headers: any = {
    'Content-Type': 'application/json'
  };

  constructor(
    private http: HttpClient,
    private gfService: GlobalFunctionService,
    private appInit: AppInitializerService
  ) { }

  saveChannel(params: any, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `channel`;
    const options = {
      headers: new HttpHeaders(headers)
    };
    return this.http.post(api, params, options);
  }

  updateChannel(params: any, id: number, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `channel/${id}`;
    const options = {
      headers: new HttpHeaders(headers)
    };
    return this.http.put(api, params, options);
  }

  getChannelList(params: any = {}, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    const api =
      this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `channel`;
    const options = {
      headers: new HttpHeaders(headers),
      params
    };
    return this.http.get(api, options);
  }

  deleteChannel(params: any = {}, id: number, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    const api =
      this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `channel/${id}`;
    headers = this.gfService.JSONMerge(headers, this.headers);
    const options = {
      headers: new HttpHeaders(headers),
      body: params
    };
    return this.http.delete(api, options);
  }

  channelDetail(id: number, headers: any = {}): Observable<any> {
    const token = this.gfService.getCookie('token');
    if (token) {
      headers.token = token;
    }
    headers = this.gfService.JSONMerge(headers, this.headers);
    const options = {
      headers: new HttpHeaders(headers)
    };
    const api = this.appInit.configuration.API_URL + '' + this.appInit.configuration.API_PREFIX + `channel/${id}`;
    return this.http.get(api, options);
  }
}
